import { ActionCreator } from '@sendoutcards/core'
// @src imports
import { Result } from 'src/utils/Result'
import { AccountFragment, PhoneNumberInput } from 'src/graphql'
import { Account, AnonymousUser } from 'src/user/fragments'
// TYPES_______________________________________________________
export type LoginResult = {
  account?: Account
  success: boolean
  message?: string
}
// ______________________________________________________________

export const updatedAccount = ActionCreator(
  'UPDATED_ACCOUNT',
  (account: AccountFragment | undefined) => ({ account }),
)

export const loginDone = ActionCreator(
  'LOGIN_DONE',
  (result: Result<AccountFragment>, rememberMe: boolean = true) => ({
    result,
    rememberMe,
  }),
)

export const loadedUser = ActionCreator(
  'LOADED_USER',
  (account: Result<AccountFragment | AnonymousUser>) => ({ account }),
)

export const unloadUser = ActionCreator('UNLOAD_USER')

export const logout = ActionCreator('LOGOUT')

export const openPhoneNumberVerification = ActionCreator(
  'OPENED_PHONE_VERIFICATION',
  (
    loginPhoneNumber: PhoneNumberInput | null = null,
    needsNewVerificationCode: boolean = false,
    shouldNotCreateNewAccount: boolean = false,
    shouldReassignNumber: boolean = false,
    shouldRememberMe: boolean = true,
  ) => ({
    loginPhoneNumber,
    needsNewVerificationCode,
    shouldNotCreateNewAccount,
    shouldReassignNumber,
    shouldRememberMe,
  }),
)

export const closePhoneNumberVerification = ActionCreator(
  'CLOSED_PHONE_VERIFICATION',
)

export const setUnverifiedAccountsFound = ActionCreator(
  'TOGGLED_UNVERIFIED_ACCOUNTS_FOUND',
  (unverifiedAccountsFound: boolean) => ({ unverifiedAccountsFound }),
)

export const setNoPhoneFound = ActionCreator(
  'TOGGLED_NO_PHONE_FOUND',
  (noPhoneFound: boolean) => ({ noPhoneFound }),
)

export const toggleIsBlankCardModalOpen = ActionCreator(
  'TOGGLED_IS_BLANK_CARD_MODAL_OPEN',
)
